import React, { Component } from 'react';
import ContentSection from './ContentSection';
import { Col, Row } from 'react-materialize';
import { FormattedMessage } from 'react-intl';

import rewards from '../../assets/landing/rewards.png';
import userFeedback from '../../assets/landing/user-feedback.png';
import watchVideo from '../../assets/landing/watch-video.png';


class LandingFeatures extends Component {

	render() {
		return (
			<ContentSection addedSectionClass='gray-bg pt-100 pb-0 section-top-border' slopeColor='white' sectionEffect='uphill'>
				<Row>
					<Col s={12} m={4} l={4} className='grid-example'>
						<div className='landing-features-content-container'>
							<img className='landing-features-icon' src={watchVideo} alt='features-icon' />
							<h3 className='landing-features-title'>
								<FormattedMessage
									id="landing_features.be_entertained.title"
									defaultMessage={"Be Entertained"}
								/>
							</h3>
							<p className='landing-features-text'>
								<FormattedMessage
									id="landing_features.be_entertained.body"
									defaultMessage={"creators give you early access to their videos"}
								/>
							</p>
						</div>
					</Col>
					<Col s={12} m={4} l={4} className='grid-example'>
						<div className='landing-features-content-container'>
							<img className='landing-features-icon' src={userFeedback} alt='features-icon' />
							<h3 className='landing-features-title'>
								<FormattedMessage
									id="landing_features.give_feedback.title"
									defaultMessage={"Give Feedback"}
								/>
							</h3>
							<p className='landing-features-text'>
								<FormattedMessage
									id="landing_features.give_feedback.body"
									defaultMessage={"give your opinion on video, inspiring change"}
								/>
							</p>
						</div>
					</Col>
					<Col s={12} m={4} l={4} className='grid-example'>
						<div className='landing-features-content-container'>
							<img className='landing-features-icon' src={rewards} alt='features-icon' />
							<h3 className='landing-features-title'>
								<FormattedMessage
									id="landing_features.earn_rewards.title"
									defaultMessage={"Earn Rewards"}
								/>
							</h3>
							<p className='landing-features-text'>
								<FormattedMessage
									id="landing_features.earn_rewards.body"
									defaultMessage={"redeem your Pilotly feedback points for gifts"}
								/>
							</p>
						</div>
					</Col>
				</Row>
			</ContentSection> 
		);
	}
}

export default LandingFeatures;



// WEBPACK FOOTER //
// ./src/components/landing/LandingFeatures.js